import PropTypes from 'prop-types';

import styles from './PieSlice.module.scss';
import {
    safeSlicing,
    getPositionX,
    getPositionY,
    handleCorrPosition,
    types
} from '../helpers';

const PieSlice = ({ data, fill, score, startAngle, cssClass }) => {
    const MAX_SCORE = 500;

    const center = 100;
    const radius = 95;

    const angle = (safeSlicing(score) * 360) / MAX_SCORE;

    let angleMargin = 0;
    let angleStart = startAngle;
    let angleEnd = startAngle;

    angleStart = angleEnd;
    angleMargin = angleMargin > angle ? angle : angleMargin;
    angleEnd = angleStart + angle - angleMargin;

    const rradius = 20;
    const textRadius = 80;
    let diffAngle = (angleEnd - angleStart) / 2;

    const x1 = getPositionX(center, radius, angleStart);
    const y1 = getPositionY(center, radius, angleStart);
    const x2 = getPositionX(center, radius, angleEnd);
    const y2 = getPositionY(center, radius, angleEnd);

    const rx1 = getPositionX(center, rradius, angleStart);
    const ry1 = getPositionY(center, rradius, angleStart);
    const rx2 = getPositionX(center, rradius, angleEnd);
    const ry2 = getPositionY(center, rradius, angleEnd);

    let tx1 = getPositionX(center, textRadius, angleStart + diffAngle);
    let ty1 = getPositionY(center, textRadius, angleStart + diffAngle);

    const isLarge = data.score > 250;

    const path = `
          M${rx1},${ry1}
          L${x1},${y1}
          A${radius},${radius} 0 ${isLarge ? 1 : 0},1 ${x2},${y2} 
          L${rx2},${ry2}
          A${rradius},${rradius} 0 ${isLarge ? 1 : 0},0 ${rx1},${ry1} 
          z`;

    if (data.id === types.cor) {
        const position = handleCorrPosition(
            data,
            center,
            textRadius,
            angleStart,
            diffAngle,
            tx1,
            ty1
        );
        tx1 = position.tx1;
        ty1 = position.ty1;
    }

    return (
        <g className={`${styles.op}  ${cssClass} slice`}>
            <path
                d={path}
                id={data.name}
                className={styles.slice}
                fill={fill}
            />
            <text x={tx1 - 3} y={ty1} className={styles.label}>
                {data.label}
            </text>
        </g>
    );
};

PieSlice.propTypes = {
    data: PropTypes.shape({
        label: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        score: PropTypes.number
    }),
    fill: PropTypes.string,
    score: PropTypes.number,
    startAngle: PropTypes.number,
    cssClass: PropTypes.string
};
export default PieSlice;
